import { RecordMetricsRq } from './api';

// TODO: Batching

export default async payload => {
  return RecordMetricsRq(payload);
};
